import { Input, InputNumber, Radio, Select, Space, Switch, Typography } from 'antd';
import type { FieldMeta } from '../../../api/types';
import type { CodeSection } from '../../../contract/types';

interface Props {
  section: CodeSection;
  onChange: (s: CodeSection) => void;
  fieldMetas: FieldMeta[];
}

export function CodeEditor({ section, onChange, fieldMetas }: Props) {
  const patch = (p: Partial<CodeSection>) => onChange({ ...section, ...p });
  return (
    <Space direction="vertical" size={10} style={{ width: '100%' }}>
      <Radio.Group
        size="small"
        value={section.codeType}
        onChange={(e) => patch({ codeType: e.target.value })}
        optionType="button"
        options={[
          { label: '二维码', value: 'qr' },
          { label: '条形码', value: 'barcode' },
        ]}
      />
      <div>
        <Typography.Text type="secondary" style={{ fontSize: 11 }}>内容字段（优先）</Typography.Text>
        <Select
          size="small"
          style={{ width: '100%' }}
          allowClear
          showSearch
          optionFilterProp="label"
          placeholder="绑定字段"
          value={section.fieldId ?? undefined}
          onChange={(v) => patch({ fieldId: v ?? null })}
          options={fieldMetas.map((m) => ({ label: m.name, value: m.id }))}
        />
      </div>
      {!section.fieldId && (
        <Input
          size="small"
          placeholder="或输入静态内容（网址 / 编号）"
          value={section.staticValue}
          onChange={(e) => patch({ staticValue: e.target.value })}
        />
      )}
      <Space size={12} wrap align="start">
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>
            {section.codeType === 'qr' ? '边长(px)' : '高度(px)'}
          </Typography.Text>
          <br />
          <InputNumber
            size="small"
            min={30}
            max={400}
            style={{ width: 80 }}
            value={section.sizePx}
            onChange={(v) => patch({ sizePx: v ?? (section.codeType === 'qr' ? 120 : 60) })}
          />
        </div>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>对齐</Typography.Text>
          <br />
          <Radio.Group
            size="small"
            value={section.align}
            onChange={(e) => patch({ align: e.target.value })}
            optionType="button"
            options={[
              { label: '左', value: 'left' },
              { label: '中', value: 'center' },
              { label: '右', value: 'right' },
            ]}
          />
        </div>
        {section.codeType === 'barcode' && (
          <div>
            <Typography.Text type="secondary" style={{ fontSize: 11 }}>显示文字</Typography.Text>
            <br />
            <Switch size="small" checked={section.showText} onChange={(v) => patch({ showText: v })} />
          </div>
        )}
      </Space>
      <Typography.Text type="secondary" style={{ fontSize: 11 }}>
        条形码为 Code128（数字/字母/常见符号）；扫码出库、溯源可用。
      </Typography.Text>
    </Space>
  );
}
